<template>
    <div id="test-orders-container">
        <b-row>
            <b-col class="col-12">
                <MdTitleRegInfo
                    v-bind:RegistrationInfo="PatientTitle"
                    v-bind:titlePrefix="$t('TestOrder.Title')"
                    v-bind:titleRef="'titleElementTestOrderList'"
                    v-bind:patientCode="this.$route.params.id"
                >
                </MdTitleRegInfo>

                <div
                    class="alert alert-fill-warning d-flex align-items-center m-3"
                    role="alert"
                    v-if="isReadOnly"
                >
                    <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                    <div class="flex-grow-1">
                        <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdButton
                    v-bind:Label="$t('TestOrder.AddTestOrder')"
                    v-bind:ClassProp="
                        this.isReadOnly
                            ? 'btn btn-primary my-3 btn-block'
                            : 'btn btn-primary my-3 btn-block btn-login'
                    "
                    v-bind:IconClass="'ti-plus pr-1'"
                    v-on:click="addTestOrder"
                    v-bind:isReadOnly="this.isReadOnly"
                    v-bind:Name="'btn_add_vitals'"
                >
                </MdButton>
            </b-col>
            <b-col lg="9" md="9" sm="12" class="mb-4">
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input
                            type="text"
                            class="form-control"
                            :dir="dirInput"
                            v-model="parameters.searchCriteria"
                            @keyup.enter="searchTestOrder"
                        />

                        <div class="input-group-append">
                            <MdButton
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="searchTestOrder"
                            >
                            </MdButton>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.datefrom')"
                    :Model="parameters.dateFrom"
                    @input="parameters.dateFrom = $event"
                    :Id="'TestOrderDateFrom'"
                    :Type="'date'"
                    :isRequired="true"
                    :OnPressEnter="searchTestOrder"
                    :isConfirm="false"
                    :ReadOnly="false"
                    :isValid="isDateFromValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdDateTime
                    :Label="$t('Shared.dateTo')"
                    :Model="parameters.dateTo"
                    @input="parameters.dateTo = $event"
                    :Id="'TestOrderDateTo'"
                    :Type="'date'"
                    :isRequired="true"
                    :OnPressEnter="searchTestOrder"
                    :isConfirm="false"
                    :ReadOnly="false"
                    :isValid="isDateToValid"
                >
                </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('TestOrder.Priority')"
                    v-bind:Options="priorities"
                    v-bind:Model="parameters.priority"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownPriority"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Location')"
                    v-bind:Options="testOrderLocations"
                    v-bind:Model="parameters.location"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:Multiple="false"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownLocation"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('TestOrder.ResultType.Title')"
                    v-bind:Options="resultTypes"
                    v-bind:Model="parameters.resultType"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownResultType"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('TestOrder.TestType.Title')"
                    v-bind:Options="testTypes"
                    v-bind:Model="parameters.testType"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownTestType"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Status')"
                    v-bind:Options="status"
                    v-bind:Model="parameters.status"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:Multiple="false"
                    v-bind:IfUsevalidation="false"
                    :Input="changeDropDownStatus"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col class="col-12">
                <MdButton
                    v-bind:Label="$t('Shared.Search')"
                    v-bind:Name="'btnSearchTestOrder'"
                    v-bind:ClassProp="'secondary mx-2 btn-login pull-right'"
                    v-on:click="searchTestOrder"
                />
            </b-col>
        </b-row>

        <MdTitle
            v-bind:Text="$t('Shared.SearchResult')"
            v-bind:isSubtitle="true"
            v-bind:Name="'T_TitleSearch'"
        />

        <b-row>
            <b-col class="col-12 mt-2">
                <MdTable
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:showMessageIsEmpty="showMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    :editIconEvent="editTestOrder"
                    v-bind:VisibleEditIcon="true"
                    v-bind:FieldsDate="fieldsDateArr"
                    :onRowSelected="onRowSelected"
                    :onFiltered="onFiltered"
                    :pageChanged="pageChanged"
                    :perPageFunction="perPageFunction"
                    :otherIcon="'printer-fill'"
                    :otherIconEvent="showReport"
                    :otherIcon2="'printer-fill'"
                    :otherIconEvent2="showTestOrderResult"
                    :deleteIconEvent="removeTestOrder"
                    :VisibleDeleteIcon="!isReadOnly"
                >
                </MdTable>
            </b-col>
        </b-row>

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:isReadOnly="items.length === 0"
                v-bind:Label="$t('Shared.Report')"
                v-bind:Name="'btnTestOrderReport'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="showSelectedReport()"
            />
        </div>
    </div>
</template>

<script>
import EnumService from '@/services/enum.service';
import Utils from '@/common/utils';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js';
import Permission from '@/common/Permission';
import TestOrdersService from '@/services/testorders.service';
import TestOrderLocationsService from '@/services/testorderlocations.service';

export default {
    name: 'TestOrderListing',
    mixins: [ShowMessage, DBFunctions, Permission],
    data() {
        return {
            OptionsRightMenu: {
                visible: true,
                ItemsList: [],
                btnvisible: true,
                itemdisabled: false,
                PatientCode: ''
            },
            RegistrationInfo: {},
            PatientInfo: {},
            showMessageIsEmpty: false,
            currentAppointmentDB: {
                guid: '',
                activitytypecode: '',
                employee: {
                    firstname: '',
                    lastname: ''
                }
            },
            PatientTitle: {
                programName: '',
                fullName: '',
                admitDate: '',
                dischargeDate: '',
                dob: '',
                activitytypename: '',
                startdatetime: '',
                ageFormatted: ''
            },
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            parameters: {
                searchCriteria: '',
                dateFrom: Utils.getCurrentDateTime('YYYY-MM-DD'),
                dateTo: Utils.getCurrentDateTime('YYYY-MM-DD'),
                priority: null,
                location: null,
                resultType: null,
                testType: null,
                status: null
            },
            isReadOnly: false,
            fields: [
                {
                    key: 'testOrder.sysDate',
                    sortable: true,
                    label: this.$t('Shared.Date'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateTimeToString(value) : '';
                    }
                },
                {
                    key: 'testOrder.testCode',
                    sortable: true,
                    label: this.$t('Shared.Code'),
                    class: 'text-left'
                },
                {
                    key: 'testOrder.testName',
                    sortable: true,
                    label: this.$t('Shared.Name'),
                    class: 'text-left'
                },
                {
                    key: 'testOrder.panelCode',
                    sortable: true,
                    label: this.$t('TestOrder.PanelCode'),
                    class: 'text-left'
                },
                {
                    key: 'testOrder.panelName',
                    sortable: true,
                    label: this.$t('TestOrder.PanelName'),
                    class: 'text-left'
                },
                {
                    key: 'testOrder.priority',
                    sortable: true,
                    label: this.$t('TestOrder.Priority'),
                    class: 'text-left'
                },
                {
                    key: 'testOrder.testSpecimen',
                    sortable: true,
                    label: this.$t('TestOrder.SRCSpecimen'),
                    class: 'text-left'
                },
                {
                    key: 'testOrder.fasting',
                    sortable: true,
                    label: this.$t('TestOrder.Fasting'),
                    class: 'text-left'
                },
                {
                    key: 'testOrder.locationName',
                    sortable: true,
                    label: this.$t('Shared.Location'),
                    class: 'text-left'
                },
                {
                    key: 'testOrder.internalStatus',
                    sortable: true,
                    label: this.$t('Shared.Status'),
                    class: 'text-left',
                    formatter: value => {
                        return value ? this.getStatusName(value) : '';
                    }
                },
                {
                    key: 'testOrderResult.resultText',
                    sortable: true,
                    label: this.$t('TestOrderResult.TextResult'),
                    class: 'text-left'
                },
                {
                    key: 'testOrderResult.datePerformed',
                    sortable: true,
                    label: this.$t('Shared.Date'),
                    class: 'text-center',
                    formatter: value => {
                        return value ? Utils.formatterDateToString(value) : '';
                    }
                },
                {
                    key: 'testOrderResult.resultNumber',
                    sortable: true,
                    label: this.$t('TestOrderResult.Result'),
                    class: 'text-right'
                },
                {
                    key: 'testOrderResult.unit',
                    sortable: true,
                    label: this.$t('TestOrderResult.Unit'),
                    class: 'text-left'
                },
                {
                    key: 'testOrderResult.resultType',
                    sortable: true,
                    label: this.$t('TestOrderResult.ResultType'),
                    class: 'text-left'
                }
            ],
            fieldsDateArr: ['testOrder.sysDate'],
            items: [],
            totalRows: 0,
            pageOptions: [5, 10, 15],
            currentPage: 1,
            perPage: 10,
            priorities: EnumService.TestOrderPriority,
            resultTypes: EnumService.TestOrderResultType,
            testTypes: EnumService.TestOrderTestType,
            status: EnumService.TestOrderStatus,
            isDateToValid: true,
            isDateFromValid: true,
            testOrderLocations: []
        };
    },
    methods: {
        getStatusName(value) {
            const index = this.status.findIndex(s => s.value === value);

            if (index !== -1) {
                return this.status[index].name;
            }

            return value;
        },

        searchTestOrder() {
            this.currentPage = 1;
            this.getTestOrders();
        },

        addTestOrder() {
            if (this.$route.name.includes('appointments-')) {
                this.$router.push({
                    name: 'appointments-test-order-add',
                    params: {
                        id: this.$route.params.id,
                        actId: this.$route.params.actId
                    }
                });
            } else {
                this.$router.push({
                    name: 'clinical-test-order-add',
                    params: { id: this.$route.params.id }
                });
            }
        },

        showTestOrderResult(item) {
            if (this.$route.name.includes('appointments-')) {
                this.$router.push({
                    name: 'appointments-test-order-result',
                    params: {
                        id: this.$route.params.id,
                        actId: this.$route.params.actId,
                        recNo: item.testOrder.recNo
                    }
                });
            } else {
                this.$router.push({
                    name: 'clinical-test-order-result',
                    params: { id: this.$route.params.id, recNo: item.testOrder.recNo }
                });
            }
        },

        editTestOrder(item) {
            if (this.$route.name.includes('appointments-')) {
                this.$router.push({
                    name: 'appointments-test-order-edit',
                    params: {
                        id: this.$route.params.id,
                        actId: this.$route.params.actId,
                        recNo: item.testOrder.recNo
                    }
                });
            } else {
                this.$router.push({
                    name: 'clinical-test-order-edit',
                    params: { id: this.$route.params.id, recNo: item.testOrder.recNo }
                });
            }
        },

        removeTestOrder(row) {
            const recNo = row.testOrder.recNo;
            if (row.internalStatus !== 'ORDERED') {
                this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('TestOrder.InvalidDelete'),
                    'error'
                );
                return;
            }

            this.$bvModal
                .msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
                    title: this.$t('TestOrder.Title'),
                    okTitle: this.$t('Shared.TitleDelete'),
                    cancelTitle: this.$t('Shared.BtnCancel'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
                .then(value => {
                    if (value) {
                        TestOrdersService.delete(recNo)
                            .then(() => {
                                this.searchTestOrder();
                            })
                            .catch(error => {
                                this.showResponseErrorMessage(error);
                            });
                    }
                });
        },

        onRowSelected() {},
        onFiltered() {},
        showReport() {},
        showSelectedReport() {},

        changeDropDownPriority(value) {
            this.parameters.priority = value ? value.value : null;
        },

        changeDropDownLocation(value) {
            this.parameters.location = value ? value.code : null;
        },

        changeDropDownResultType(value) {
            this.parameters.resultType = value ? value.value : null;
        },

        changeDropDownTestType(value) {
            this.parameters.testType = value ? value.value : null;
        },

        changeDropDownStatus(value) {
            this.parameters.status = value ? value.value : null;
        },

        pageChanged(page) {
            this.currentPage = page;
            this.getTestOrders();
        },

        perPageFunction(perPage) {
            this.perPage = perPage;
            this.currentPage = 1;
            this.getTestOrders();
        },

        async getTestOrders() {
            const parameters = {
                PageSize: this.perPage,
                PageNumber: this.currentPage,
                PatientCode: this.$route.params.id,
                ...this.parameters
            };

            const result = Utils.validateDateRange(
                this.parameters.dateFrom,
                this.parameters.dateTo
            );
            if (!result.valid) {
                this.isDateToValid = !result.fields.includes('toDate');
                this.isDateFromValid = !result.fields.includes('fromDate');
                this.showMessage(this.$tc('Msg.Error'), this.$t(result.message), 'error');
                return;
            }

            await TestOrdersService.getAllListing(parameters)
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.items = response.data;
                        let headerString = response.headers['x-pagination'];
                        const header = JSON.parse(headerString);
                        this.totalRows = header.TotalCount;
                    }

                    this.showMessageIsEmpty = this.totalRows === 0;
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        },

        async getCurrentAppointment() {
            this.currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
            this.PatientTitle.activitytypename = this.currentAppointmentDB.activitytypename;
            this.PatientTitle.startdatetime = `${Utils.formatterDateToString(
                this.currentAppointmentDB.transdate
            )} ${this.currentAppointmentDB.timein}`;
        },

        PopulatePatientTitle() {
            if (this.$route.name.includes('clinical-')) {
                const {
                    dob,
                    dateFrom,
                    dateTo,
                    age,
                    programName,
                    patientName,
                    ageFormatted
                } = this.RegistrationInfo; // Destructure for easier access

                if (programName) this.PatientTitle.programName = programName;
                if (dateFrom) this.PatientTitle.dateFrom = this.RegistrationInfo.dateFrom;
                if (dateTo) this.PatientTitle.dateTo = this.RegistrationInfo.dateTo;
                if (patientName) this.PatientTitle.fullName = patientName;
                if (dob) this.PatientTitle.dob = this.PatientInfo.dob;
                if (age) this.PatientTitle.age = age === 0 ? '0' : age;
                if (ageFormatted)
                    this.PatientTitle.ageFormatted = this.RegistrationInfo.ageFormatted;
            }
        },

        async GetPatientByCode() {
            var infoList = await this.getInfoTitle(this.$route.params.id);
            if (infoList.length > 0) {
                this.PatientTitle.programName = '';
                this.PatientTitle.admitDate = '';
                this.PatientTitle.dischargeDate = '';

                const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = firstname + ' ' + lastname;
            }
        },

        async registrationInfoTitleAsync() {
            this.RegistrationInfo = await this.getRegistrationInfoTitle(
                this.$route.params.recordid
            );
            const { dob, dateFrom, dateTo, age } = this.RegistrationInfo; // Destructure for easier access

            if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
            if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);
            if (dob) this.RegistrationInfo.dob = Utils.formatterDateToString(dob);
            if (age) this.RegistrationInfo.age = age === 0 ? '0' : age;
        },

        async getTestOrderLocations() {
            await TestOrderLocationsService.getLookup()
                .then(response => {
                    if (response.status == '200' && response.data) {
                        this.testOrderLocations = response.data;
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                });
        }
    },

    async mounted() {
        this.OptionsRightMenu.visible = true;
        this.OptionsRightMenu.ItemsList = this.$route.name.includes('appointments-')
            ? EnumService.AppointmentItems
            : EnumService.ClinicalItems;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        this.$emit('getBtnRightMenu', this.OptionsRightMenu);
        this.isReadOnly = this.$store.state.isTestOrdersEHRReadOnly;

        const settled = [
            this.registrationInfoTitleAsync(),
            this.PopulatePatientTitle(),
            this.GetPatientByCode(),
            this.getTestOrders(),
            this.getTestOrderLocations()
        ];

        if (this.$route.name.includes('appointments-')) {
            settled.push(this.getCurrentAppointment());
        }

        await Promise.allSettled(settled);
    },

    destroyed() {
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    }
};
</script>
